module.exports = __webpack_public_path__ + "img/stock2.8d740725.png";